module.exports = __webpack_public_path__ + "img/1.9d46a1c5.png";